const DISPLAY_MODES = {
  COLUMN: 0,
  ROW: 1,
}

export default DISPLAY_MODES
